import { Trans, useTranslation } from 'react-i18next';
import LegalPage from '@/components/legal/LegalPage';

/**
 * Reads bullets/sections from i18n. Each section is a heading + paragraphs/list.
 * Structure: legal.privacy.sections = [{ heading, paragraphs: [...], list?: [...] }]
 */
export default function PrivacyPolicyPage() {
  const { t } = useTranslation();
  const sections = t('legal.privacy.sections', { returnObjects: true }) || [];
  const updated = t('legal.lastUpdated');

  return (
    <LegalPage titleKey="legal.privacy.title" testIdSuffix="privacy">
      <p className="text-sm text-muted-foreground mb-6" data-testid="legal-last-updated">
        {updated}
      </p>
      <p>{t('legal.privacy.intro')}</p>

      {Array.isArray(sections) && sections.map((s, i) => (
        <section key={i} className="mt-6">
          <h2 className="text-lg font-semibold mt-6 mb-2 text-foreground" style={{ fontFamily: 'Outfit' }}>
            {s.heading}
          </h2>
          {(s.paragraphs || []).map((p, j) => (
            <p key={j} className="mb-2">{p}</p>
          ))}
          {Array.isArray(s.list) && s.list.length > 0 && (
            <ul className="list-disc pl-6 mb-2 space-y-1">
              {s.list.map((it, k) => <li key={k}>{it}</li>)}
            </ul>
          )}
        </section>
      ))}

      <section className="mt-8 p-4 border border-border rounded-md bg-muted/40">
        <h2 className="text-base font-semibold mb-2" style={{ fontFamily: 'Outfit' }}>
          {t('legal.affiliate.heading')}
        </h2>
        <p className="text-sm">
          <Trans
            i18nKey="legal.affiliate.body"
            components={{ strong: <strong /> }}
          />
        </p>
      </section>

      <p className="mt-8 text-sm text-muted-foreground">
        <Trans
          i18nKey="legal.contactLine"
          components={{
            mail: <a className="underline hover:text-foreground" href="mailto:offertes@powersure-worldwide.com" />,
          }}
        />
      </p>
    </LegalPage>
  );
}
